import communityStore from './community.js'
import amenityStore from './amenity'
import favoriteStore from './favorite'
import r6analytics from "@/store/r6analytics";

export default {
  communityStore,
  amenityStore,
  favoriteStore,
  r6analytics
}



// WEBPACK FOOTER //
// ./src/store/modules.js